import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box, Icon, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

import { useTests } from '../Contexts/TestsContext'

const Recap = ({ result, gateway }) => {
  const { useGetTestConfig } = useTests()

  const [isLorawan] = useState(result.result.snr ? true : false)
  const [successColor, setSuccessColor] = useState('success')

  function toDate(timestamp) {
    return new Date(timestamp).toLocaleDateString('it-IT')
  }

  function toTime(timestamp) {
    return new Date(timestamp).toLocaleTimeString('it-IT', {
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  useEffect(() => {
    useGetTestConfig().then((res) => {
      if (isLorawan) {
        if (result.result.rssi > Number(res.data.rssi) || result.result.snr > Number(res.data.snr)) {
          setSuccessColor('success')
        }
        else {
          setSuccessColor('warning')
        }
      } else {
        if (result.result.rssi > Number(res.data.rssi)) {
          setSuccessColor('success')
        }
        else {
          setSuccessColor('warning')
        }
      }
    })
  }, [])

  return (
    <Stack
      display="flex"
      flexDirection="column"
      marginTop={5}
    >

      <Box display='flex' justifyContent='center'>
        <Icon color={successColor} sx={{ fontSize: '8rem' }}>
          <CheckCircleOutlineIcon sx={{ fontSize: '8rem' }} />
        </Icon>
      </Box>

      <Typography variant="h4" textAlign={'center'} marginBottom={5} color={successColor}>
        {
          successColor == 'success' ? `Test trasmissione ${isLorawan ? 'Lorawan' : 'WMBus'} OK` : 'Verifica Impianto'
        }
      </Typography>

      <Box marginBottom={5}>
        <Typography textAlign={'left'} fontWeight={'bold'}>
          Data di verifica
        </Typography>

        <Typography textAlign={'left'}>
          {toDate(result.result.timestamp)}
        </Typography>

        <Typography textAlign={'left'} fontWeight={'bold'}>
          Ora di test
        </Typography>

        <Typography textAlign={'left'}>
          {toTime(result.result.timestamp)}
        </Typography>
      </Box>

      <Typography variant="body2" fontWeight={'bold'} textAlign={'left'}>
        Numero seriale
      </Typography>
      <Box
        display="flex"
        height={20}
        backgroundColor={'#e0e0e0'}
        borderRadius={'10px'}
      >
        <Typography variant="body2" textAlign={'left'} marginLeft={3} id="recap-serial">
          {result.serial}
        </Typography>
      </Box>

      {isLorawan ? <>
      </> : <>
        <Typography variant="body2" fontWeight={'bold'} textAlign={'left'}>
          WMBus ID
        </Typography>
        <Box
          display="flex"
          height={20}
          backgroundColor={'#e0e0e0'}
          borderRadius={'10px'}
        >
          <Typography variant="body2" textAlign={'left'} marginLeft={3} id="recap-wmbusid">
            {gateway.wmbusId}
          </Typography>
        </Box></>}

      <Typography variant="body2" fontWeight={'bold'} textAlign={'left'}>
        rssi
      </Typography>
      <Box
        display="flex"
        height={20}
        backgroundColor={'#e0e0e0'}
        borderRadius={'10px'}
      >
        <Typography variant="body2" textAlign={'left'} marginLeft={3} id="recap-rssi">
          {result.result.rssi}
        </Typography>
      </Box>

      {isLorawan ? <>
        <Typography variant="body2" fontWeight={'bold'} textAlign={'left'}>
          snr
        </Typography>
        <Box
          display="flex"
          height={20}
          backgroundColor={'#e0e0e0'}
          borderRadius={'10px'}
        >
          <Typography variant="body2" textAlign={'left'} marginLeft={3} id="recap-snr">
            {result.result.snr}
          </Typography>
        </Box>
      </> : <></>}
    </Stack>
  )
}

export default Recap